var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 172,
    viewBox: "0 0 239 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3643_27111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.953 0.733164C131.5 4.52401 108.344 22.2784 97.4407 50.1951C92.3678 63.1864 92.4305 63.4618 101.056 65.9959C111.596 69.0912 122.886 74.5486 129.707 79.847L135.621 84.4394L137.074 75.5532C139.304 61.9013 143.076 53.209 150.168 45.37C157.774 36.9608 164.898 33.8022 176.253 33.8022C194.541 33.8022 207.424 45.9893 213.282 68.8287C215.949 79.2251 216.009 107.26 213.387 117.431C207.726 139.389 194.393 152.167 177.052 152.252C165.1 152.311 159.428 150.01 151.308 141.806C143.138 133.552 139.375 125.258 136.645 109.491C135.146 100.835 134.465 99.458 128.841 93.689C119.81 84.4239 107.799 79.004 81.6844 72.4049C57.0132 66.1718 50.1818 63.3092 47.9 58.2488C45.0142 51.8488 45.9663 46.4146 50.8371 41.4938C56.7188 35.5528 65.8448 32.8209 78.7575 33.1363L88.7499 33.3807L93.3263 26.5166C95.8423 22.7413 100.992 16.4292 104.769 12.4897C108.545 8.55017 111.636 5.21701 111.636 5.08513C111.636 4.95196 107.748 4.04951 102.997 3.07982C90.1883 0.466825 59.35 0.771946 48.9277 3.61637C29.4997 8.91735 12.5774 21.3501 5.83311 35.2774C1.3322 44.5722 0.150992 62.2865 3.30176 73.2363C9.3998 94.4299 23.879 104.168 63.5489 113.756C89.2055 119.959 92.4164 121.956 96.8687 134.488C103.961 154.447 119.794 171.293 139.167 179.491C162.313 189.286 197.551 187.876 219.537 176.273C231.096 170.173 245.486 155.091 251.387 142.892C259.412 126.302 260.697 119.432 260.697 93.115C260.697 66.7975 259.412 59.9283 251.387 43.3375C245.486 31.1388 231.096 16.0569 219.537 9.95687C204.481 2.01187 181.392 -1.68718 161.953 0.733164ZM0.296875 151.146V172.33L9.57512 175.806C26.4935 182.147 38.2391 184.421 57.9589 185.179C78.778 185.978 92.8502 183.97 104.802 178.492L111.405 175.465L105.877 169.467C102.836 166.169 97.9769 159.793 95.0796 155.301L89.8108 147.131L84.4064 149.86C79.8453 152.164 76.7048 152.589 64.2848 152.585C43.6026 152.58 30.9586 148.508 11.6432 135.625C6.97337 132.512 2.50957 129.963 1.72508 129.963C0.731989 129.963 0.296875 136.424 0.296875 151.146Z",
    fill: "url(#paint0_linear_3643_27111)",
    fillOpacity: 0.06
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3643_27111",
    x: 0.296875,
    y: 0,
    width: 260.398,
    height: 186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.44
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0 0.129412 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3643_27111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3643_27111",
    x1: 200.004,
    y1: -5.00001,
    x2: -23.5863,
    y2: 245.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.423288,
    stopColor: "#FE0083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF0067"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLogo);
export default __webpack_public_path__ + "static/media/lightLogo.6c29d56b3c8e28ee318e68abac94a729.svg";
export { ForwardRef as ReactComponent };